import styled from 'styled-components';

export const Title = styled.h1`
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 20px;
  font-weight: bold;
  line-height: 1.3;
  color: #1b1b1b;
`;

export const TitleBox = styled.h2`
  margin: 0;
  color: #1b1b1b;
  padding: 40px 0 0;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0;
`;
